<div>
    <mat-expansion-panel
            class="light-flex-card tv-mat-expansion-indicator-light-bg"
    >
        <mat-expansion-panel-header>
            <mat-panel-title class="sub-title">
                Engagement
            </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="content">
            <div class="categories-container">
                <div *ngFor="let group of groupedCommitmentList" class="medium-category">
                    <app-commitment-group
                            [group]="group"
                            [isPastYearContract]="isPastYearContract"
                            (commitmentsChange)="commitmentsChange($event)"
                            class="full-height"
                    ></app-commitment-group>
                </div>
            </div>
            <div class="calcul-container">
                <div class="categories-container">
                    <div class="criteria-categories-container">
                        <span class="third-title">Critères</span>

                        <div class="full-size-category" *ngFor="let group of groupedCriteriaList; let i = index">
                            <app-criteria-group
                                    [group]="group"
                                    [isPastYearContract]="isPastYearContract"
                                    (groupValueChange)="updateGroupCriteria($event, i)"
                                    (groupBaseValueChange)="callUpdateGroupCriteria($event, i)"
                            >
                            </app-criteria-group>
                        </div>

                        <mat-divider></mat-divider>

                        <!-- Taux CGV -->
                        <div class="full-size-category">
                            <div class="commitment-container">
                                <span class="commitment-title">Taux CGV</span>
                                <div class="tv-rect-input-small-no-label width-180px disabled-form-field">
                                    <mat-form-field>
                                        <input
                                                matInput
                                                [disabled]="true"
                                                [readonly]="true"
                                                [value]="groupCriteriaValue"

                                        />
                                        <span matSuffix class="commitment-suffix">%</span>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div *ngFor="let group of groupedCriteriaDateList">
                                <criteria-commitment-date-group
                                        [group]="group"
                                        [isPastYearContract]="isPastYearContract"
                                ></criteria-commitment-date-group>
                            </div>
                        </div>
                    </div>

                    <!-- CA Net Total -->
                    <div class="criteria-categories-parent-container">
                        <div class="criteria-categories-child-container">
                            <div class="full-size-category">
                                <span class="third-title">CA Net Total</span>
                                <div *ngFor="let group of groupedTotalList" class="full-size-category">
                                    <criteria-base-group
                                            [group]="group"
                                            [isPastYearContract]="isPastYearContract"
                                    ></criteria-base-group>
                                </div>
                            </div>
                        </div>

                        <!-- Taux Projeté -->
                        <div class="criteria-categories-child-container">
                            <div class="full-size-category">
                                <span class="third-title">Taux Projeté</span>
                                <div class="full-size-category">
                                    <div class="projected-rate-container">
                                        <span class="commitment-title">Valeur</span>
                                        <div class="projected-rate">
                                            <div class="tv-rect-input-small-no-label width-180px">
                                                <mat-form-field>
                                                    <input
                                                            matInput
                                                            type="number"
                                                            min="0"
                                                            max="100"
                                                            step="1"
                                                            [formControl]="projectedRateFormControl"
                                                            (input)="onProjectedRateInput($event)"
                                                            (keydown)="onKeyDown($event)"
                                                    />
                                                    <span matSuffix class="commitment-suffix">%</span>
                                                </mat-form-field>
                                            </div>

                                            <div class="projected-rate-error">
                                                <mat-error class="error"
                                                           *ngIf="projectedRateFormControl.hasError('required')">
                                                    Veuillez renseigner une valeur
                                                </mat-error>
                                                <mat-error class="error"
                                                           *ngIf="projectedRateFormControl.hasError('projectedRateTooLow') && projectedRateFormControl.touched">
                                                    Attention le taux est inférieur au taux CGV
                                                    ({{groupCriteriaValue}}%)
                                                </mat-error>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <!-- END -->

                    </div>
                </div>
            </div>
            <div class="action-buttons-container">
                <button
                        class="tv-ns-secondary-large-button-on-light-bg"
                        (click)="cancelFormsModification()">
                    Annuler
                </button>
                <button
                        class="tv-ns-validation-large-button"
                        [disabled]="!editionMode || isPastYearContract"
                        (click)="saveForms()">
                    Valider
                </button>
            </div>
        </div>
    </mat-expansion-panel>
</div>
